import { useCallback } from 'react'
import Cookie from 'cookie-universal'
import { GetServerSidePropsContext, NextPageContext } from 'next'

import { ONE_MONTH } from '@mc/constants'
import { QUIZ_QUERY_PARAMS } from '@mc/find-my-classes'
import { paths } from '@mc/paths'
import { usePromotion } from '@mc/promo-utils'

import { useDynamicRouter } from './useDynamicRouter'

export const QUIZ_ONLY_ONCE_NEXT_PAGE_URL = 'quiz-next-href'

const cookieClient = Cookie()

export const getSSRQuizOnlyOnceCookie = async (
  ctx: GetServerSidePropsContext | NextPageContext,
) => {
  if (ctx.req && 'cookies' in ctx.req) {
    const cookie = ctx.req?.cookies[QUIZ_ONLY_ONCE_NEXT_PAGE_URL] ?? ''
    return cookie ?? null
  }
  return null
}

const setNextPage = (url: string) => {
  const name = QUIZ_ONLY_ONCE_NEXT_PAGE_URL
  cookieClient.set(name, JSON.stringify(url), {
    path: '/',
    maxAge: ONE_MONTH,
  })
}

export const useQuizOnlyOnceSetNextPage = () => {
  const router = useDynamicRouter()
  const { isPromotionOn } = usePromotion()

  const setNextPageUrl = useCallback(() => {
    let nextRoute = router.asPath

    // User haven't seen the promotion page yet because they clicked the hero quiz
    // https://github.com/yankaindustries/masterclass/blob/4154f100a9c81ff524a3e0369a1731f14fb740fc/web/apps/next/src/pages/find-my-classes/components/Results/Aside.tsx#L29
    const fromHeroQuiz = router.query[QUIZ_QUERY_PARAMS.SKIP_Q1] === 't'

    if (isPromotionOn && fromHeroQuiz) {
      // Preventing the user from seeing the promo page again the next time they land in the quiz results
      nextRoute = nextRoute.replace(`${QUIZ_QUERY_PARAMS.SKIP_Q1}=t`, '')

      setNextPage(paths.promotionRedirect(nextRoute))
    } else {
      setNextPage(nextRoute)
    }
  }, [isPromotionOn, router])

  return {
    setNextPageUrl,
  }
}
